import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

import { TextInput, useListContext } from 'react-admin';

const SearchField = ({ source, label }: { source: string; label?: string; alwaysOn?: boolean }) => {
  const { isFetching } = useListContext();
  return (
    <TextInput
      slotProps={{
        input: {
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
              {isFetching ? <CircularProgress size={22} /> : <SearchIcon />}
            </InputAdornment>
          ),
        },
      }}
      source={source}
      label={label}
      alwaysOn
    />
  );
};

export default SearchField;
